<template>
  <main class="min-h-screen">
    <slot />
  </main>
</template>
